

























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})

export default class StatementCheck extends Vue {
  @Prop({ required: true })
  statements!: string[];

  @Prop({ required: true })
  language!: string;

  // eslint-disable-next-line global-require, import/no-dynamic-require
  text = require(`@/text_${this.language}.json`);

  s1 = -1; // user's answer to statement 1

  s2 = -1;

  s3 = -1;

  // switch answer n to true if false and vice versa
  toggleBox(n:number):void {
    if (n === 1) {
      this.s1 = (this.s1 + 1) % 2;
    } else if (n === 2) {
      this.s2 = (this.s2 + 1) % 2;
    } else if (n === 3) {
      this.s3 = (this.s3 + 1) % 2;
    }
  }

  // set answer n to true
  setTrue(n:number):void {
    if (n === 1) {
      this.s1 = 0;
    } else if (n === 2) {
      this.s2 = 0;
    } else if (n === 3) {
      this.s3 = 0;
    }
  }

  // set answer n to false
  setFalse(n:number):void {
    if (n === 1) {
      this.s1 = 1;
    } else if (n === 2) {
      this.s2 = 1;
    } else if (n === 3) {
      this.s3 = 1;
    }
  }

  // check state of statement n
  checkState(n:number):number {
    if (n === 1) {
      return this.s1;
    }
    if (n === 2) {
      return this.s2;
    }
    return this.s3;
  }

  // check if user's answers are correct
  checkSolution():void {
    const s1sol = this.s1 === 0;
    const s2sol = this.s2 === 0;
    const s3sol = this.s3 === 0;
  }
}

